"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SkeletonOverrides = {
    MuiSkeleton: {
        defaultProps: {
            animation: 'wave',
        },
    },
};
exports.default = SkeletonOverrides;
//# sourceMappingURL=SkeletonOverrides.js.map